import * as constants from './constants';
import * as g_constants from '../../global/constants';

const initialState = {
  formData: constants.initialFormData,
  photos: [],
  calendars: [],
  listingData: constants.initListingData,
  listingCollection: [],
  listingBookings: [],
  discounts: [],
  searchedDiscount: null
};

export default function Listing(state = initialState, action) {
  switch (action.type) {
    case constants.REINITIALIZE_CALENDARS:
      return Object.assign({}, state, {
        calendars: []
      });
    case constants.REINITIALIZE_FORM_DATA:
      return Object.assign({}, state, {
        formData: constants.initialFormData
      });
    case constants.REINITIALIZE_PHOTOS:
      return Object.assign({}, state, {
        photos: []
      });
    case constants.UPDATE_FORM_DATA:
      let combinedFormData = Object.assign({}, state.formData, action.data);
      return Object.assign({}, state, {
        formData: combinedFormData
      });
    case constants.UPDATE_LISTING_PHOTOS:
      let newFormData = state.formData;
      newFormData.photos = action.data.map(x => x.name);
      return Object.assign({}, state, {
        formData: newFormData,
        photos: action.data
      });
    case constants.UPDATE_LISTING_PHOTOS_ORDER:
      let newFormDataOrderedPhotos = state.formData;
      newFormDataOrderedPhotos.photos = action.data;
      return Object.assign({}, state, {
        formData: newFormDataOrderedPhotos
      });
    case constants.UPDATE_ICALS:
      return Object.assign({}, state, {
        calendars: state.calendars.concat(action.data)
      });
    case constants.SET_LISTING:
      return Object.assign({}, state, {
        listingData: action.data
      });
    case constants.SET_LISTING_BOOKINGS:
      return Object.assign({}, state, {
        listingBookings: action.data
      });
    case constants.SET_LISTING_COLLECTION:
      return Object.assign({}, state, {
        listingCollection: action.data
      });
    case g_constants.IMPERSONATE:
    case constants.SET_DISCOUNTS:
      return Object.assign({}, state, {
        discounts: action.data
      });
    case constants.SET_SEARCHED_DISCOUNT:
      return Object.assign({}, state, {
        searchedDiscount: action.data
      });
    case g_constants.LOGOUT:
      return Object.assign({}, initialState);
    default:
      return state;
  }
}
